import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ab4541dc")

_pushScopeId("data-v-ab4541dc")
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "爬取书籍",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formDom",
        model: _ctx.formData,
        "label-width": "180px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            required: "",
            label: "来源"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.bookSource,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.bookSource = $event)),
                placeholder: "请选择来源"
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bookSources, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.formData.bookSource === '163' || _ctx.formData.bookSource === 'jd')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                required: "",
                prop: "bookId",
                rules: [{
                      required: true, message: '书籍Id不能为空'
                    }],
                label: "书籍Id"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "input",
                    rows: "2",
                    modelValue: _ctx.formData.bookId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.bookId = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.bookSource === '163')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                required: "",
                prop: "readerUCookie",
                rules: [{
                      required: true, message: 'READER_U Cookie不能为空'
                    }],
                label: "READER_U Cookie"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "input",
                    rows: "2",
                    modelValue: _ctx.formData.readerUCookie,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.readerUCookie = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.bookSource === 'wx-articles')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                required: "",
                prop: "articleUrl",
                rules: [{
                      required: true, message: '文章地址不能为空'
                    }],
                label: "文章地址"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "input",
                    rows: "2",
                    modelValue: _ctx.formData.articleUrl,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.articleUrl = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.bookSource === 'jd')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                required: "",
                prop: "u",
                rules: [{
                      required: true, message: '_u LocalStorage不能为空'
                    }],
                label: "_u LocalStorage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "input",
                    rows: "2",
                    modelValue: _ctx.formData.u,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.u = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.bookSource === 'jd')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                required: "",
                prop: "ptKey",
                rules: [{
                      required: true, message: 'pt_key Cookie不能为空'
                    }],
                label: "pt_key Cookie"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "input",
                    rows: "2",
                    modelValue: _ctx.formData.ptKey,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.ptKey = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _ctx.confirm
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})